import React, { useEffect, useState } from "react";
import { abhaSuggestionsServices, abhaCreateServices } from "../../services";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

const AbhaAddress = ({ setAdhaaddress }) => {
  const [abhaaddress, setAbhaaddress] = useState("");
  const [suggestionList, setsuggestionList] = useState([]);
  const userInfo = useSelector((state) => state.user.patientDetails);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const body = {
        referenceId: uuidv4(),
        txnId: localStorage.getItem("txnId"),
        abhaAddress: abhaaddress,
        mobile: userInfo.mobile,
        xToken: userInfo.xToken,
      };
      const response = await abhaCreateServices({ body });
      if (response.status) {
        setAdhaaddress(true);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  const getsuggesion = async () => {
    try {
      const body = {
        txnId: localStorage.getItem("txnId"),
      };
      const response = await abhaSuggestionsServices({ body });
      if (response.status) {
        let suggestiondata = response.result.abhaAddressList;
        setsuggestionList(suggestiondata);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  useEffect(() => {
    getsuggesion();
  }, []);

  return (
    <>
        <section className="container">
  <div className="abha-create-steps">
  <div className="row">
          <div className="col-md-6">
          <div className="create-abha">
          <h2>Create ABHA Number in 3 Steps</h2>
          <p>
            Create ABHA Address and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">
              Ayushman Bharat Digital Mission (ABDM)
            </span>{" "}
            and get started on your digital health journey.
          </p>

          {/* Steps */}
          <div className="vertical-steps">
            <div className="step-item">
              <div className="step-marker">1</div>
              <div className="step-content">
                <h4>Verify Aadhaar Details</h4>
                <p>
                  Enter your Aadhaar number and verify with OTP received on
                  Aadhaar linked mobile number.
                </p>
              </div>
            </div>

            <div className="step-line" />

            <div className="step-item">
              <div className="step-marker">2</div>
              <div className="step-content">
                <h4>Link Mobile Number</h4>
                <p>
                  Enter your mobile number and verify with OTP to link with ABHA
                  Address.
                </p>
              </div>
            </div>

            <div className="step-line" />

            <div className="step-item">
              <div className="step-marker">3</div>
              <div className="step-content">
                <h4>Create ABHA</h4>
                <p>Create your ABHA Number with a unique ABHA address.</p>
              </div>
            </div>
          </div>
        </div>
          </div>

        {/* Right Form Card */}
        <div className="col-md-6">
        <div className="form-card content">
          <h3>Choose your Pathkind Profile</h3>
          <p>Choose profile to create/link your ABHA Address</p>
          <form onSubmit={handleSubmit} className="pt-3">
            <div className="col-ms-10 col-lg-10 col-xl-10 col-sm-10 col-xs-10">
              <div className="d-flex align-items-center">
                <input
                  type="text"
                  className="form-control suggestion-input"
                  placeholder="Enter your ABHA Address"
                  value={abhaaddress}
                  onChange={(e) => setAbhaaddress(e.target.value)}
                />
                <p className="patient-name suggestion-input-placeholder">
                  @abdm
                </p>
              </div>
              <p className="pt-3">8-18 Characters Alphabets And Numbers Only</p>
              <p className="pt-3 pb-1">Suggestions:</p>
              <div className="row">
                <div className="suggestion-profile">
                  {suggestionList.map((suggestion, index) => (
                    <div
                      key={index}
                      className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12"
                      onClick={() => setAbhaaddress(suggestion)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center suggestion p-2 mb-2 rounded">
                        <h5 className="mb-1 suggestion-address">
                          {suggestion}@abdm
                        </h5>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12 pt-3">
              <div className="row">
                <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                  <button type="submit" className="confirm-btn">
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        </div>
        </div>
      </div>
      </section>
    </>
  );
};

export default AbhaAddress;
